import style from './LoadingScreen.css';
import LoadingAnimatedImage from '../../../assets/images/loading-animated.gif';

export default function LoadingScreen({ className = '' }) {
  return (
    <div className={`${className} ${style.container}`}>
      <img src={LoadingAnimatedImage} className={style.icon} />
    </div>
  );
}
